import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
const CONTAINER_CSS = css `
  color: black;
  padding: 5px;
`;
export const PanelContentContainer = ({ children }) => {
    return (_jsx(Typography, { css: CONTAINER_CSS, component: 'div', children: children }));
};
